var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-formbar',[_c('div',{class:_vm.inserindo ? 'hide' : 'show'},[(!_vm.inserindo)?_c('div',{staticClass:"itens"},[_c('div',{staticClass:"item"},[_c('label',[_vm._v("Dados")])])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }